<template>
  <v-btn 
  :large="large"
  icon
  :to="href ? null : to"
  :href="href"
  :target="target"
  :text="text"
  :depressed="depressed"
  :loading="loading"
  :disabled="disabled"
  class="d-flex justify-center align-center"
  style="position: relative;"
  @click="$emit('click')">
    <mdi-icon
    :src="src"
    :size="size"
    :color="color"/>
    <div
    :style="`position: absolute; z-index: 2; width: 100%; height: 100%; cursor: pointer;`"/>
  </v-btn>
</template>
<script>
export default {
  components: {
    MdiIcon: () => import('@/components/btns/MdiIcon')
  },
  props: {
    src: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      defualt: () => {
        return 30
      }
    },
    text: {
      type: Boolean,
      defualt: () => {
        return false
      }
    },
    large: {
      type: Boolean,
      defualt: true
    },
    color: {
      type: String,
      defualt: () => {
        return 'black'
      }
    },
    depressed: {
      type: Boolean,
      defualt: () => {
        return false
      }
    },
    disabled: {
      type: Boolean,
      defualt: () => {
        return false
      }
    },
    loading: {
      type: Boolean,
      defualt: () => {
        return false
      }
    },
    to: {
      type: String,
      defualt: () => {
        return null
      }
    },
    href: {
      type: String,
      defualt: () => {
        return null
      }
    },
    target: {
      type: String,
      defualt: () => {
        return '_self'
      }
    }
  }
}
</script>
<style>

</style>